module.exports = __webpack_public_path__ + "static/media/guitarist.e6d474e2.jpg";